import { CADOperationTypeEnum, LayerTypeEnum } from "../enums";
import { ICADLayer } from "../interfaces";

export default function useCADAvailableOperations(selectedLayer: ICADLayer | undefined | null) {
    let availableOperationTypes: CADOperationTypeEnum[]

    if (selectedLayer?.layerType === LayerTypeEnum.Grid) {
        availableOperationTypes = [];
    } else if (selectedLayer?.layerType === LayerTypeEnum.Spacer) {
        availableOperationTypes = [CADOperationTypeEnum.Grids];
    }
    else {

        availableOperationTypes = [CADOperationTypeEnum.EdgeProcessing, CADOperationTypeEnum.EdgeCutout, CADOperationTypeEnum.CornerCutout, CADOperationTypeEnum.InternalCutout, CADOperationTypeEnum.DrillHole];

        if (selectedLayer?.disabledOperationTypes && selectedLayer.disabledOperationTypes.length > 0) {

            // Filter out the disabled operation types
            availableOperationTypes = availableOperationTypes.filter(opType => !selectedLayer.disabledOperationTypes.includes(opType));
        }
    }

    return availableOperationTypes;
}

